module.exports = __webpack_public_path__ + "img/survey.d61f6581.png";